import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { Button, Chip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RippleEffect from 'src/components/general/RippleEffect';
import { useStore } from 'src/stores';
import useStyles from '../styles';
import { dateToFormat } from 'src/utils/date';
export const MoveOutCell = observer(props => {
  var _params$row;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const params = props.params,
    openTenantModal = props.openTenantModal,
    changeCurrentResidentId = props.changeCurrentResidentId,
    changeCurrentUnitName = props.changeCurrentUnitName;
  const handleFSEClick = event => {
    event.stopPropagation();
    event.preventDefault();
    store.fse.setFSEBillModalData({
      accountId: params.row.accountId,
      residentName: params.row.fullname,
      residencyId: params.row.residencyId,
      unitName: params.row.Unitname
    });
    store.fse.setFSEBillGeneralModalIsOpen(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.flexBox
  }, !params.row.accountId && /*#__PURE__*/React.createElement("span", {
    className: classes.disabledCellText
  }, "N/A"), !!params.row.accountId && !params.row.moveOutDateOnly && /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      openTenantModal('move-out');
      changeCurrentResidentId(params.row.residencyId);
      changeCurrentUnitName(params.row.unitName);
    },
    'custom-attribute': '221-MoveoutCell'
  }, t('Schedule')), !!params.row.accountId && !!params.row.moveOutDateOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      openTenantModal('move-out');
      changeCurrentResidentId(params.row.residencyId);
      changeCurrentUnitName(params.row.unitName);
    },
    'custom-attribute': '222-MoveoutCell'
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, dateToFormat(params.row.moveOutDateOnly))), store.account.featureFlagsStore.isFinalStatementEstimationEnabled && params.row.finalStatement && params.row.finalStatement.status !== 'Overdue' && params.row.finalStatement.fseId && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.chipsWrapper, " ").concat(classes.moveOutChips)
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: params.row.finalStatement.status === 'ReadyForReview' ? 'Final statementis ready. Click to review' : params.row.finalStatement.status === 'Inactive' ? 'The move-out bill is still inactive and will become active 30 days before the move out.' : 'Final statement was sent.',
    type: params.row.finalStatement.status === 'ReadyForReview' ? 'success-bold' : params.row.finalStatement.status === 'Inactive' ? 'warning' : undefined
  }, params.row.finalStatement.status === 'ReadyForReview' ? /*#__PURE__*/React.createElement(Chip, {
    color: "success",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "paper-dollar"
    }),
    onClick: handleFSEClick,
    'custom-attribute': '223-MoveoutCell',
    variant: "portal"
  }) : /*#__PURE__*/React.createElement(Chip, {
    color: params.row.finalStatement.status === 'Inactive' ? 'warning' : undefined,
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "paper-dollar"
    }),
    variant: "portal"
  })))));
});